export default {
  GET_APPLICATIONS_MATERIAL: state => state.applicationMaterial,
  GET_APPLICATIONS_MATERIAL_ID: state => state.applicationMaterialId,

  
  GET_APPLICATION_INSTRUMENT: state => state.applicationInstrument,
  GET_APPLICATIONS_INSTRUMENT_ID: state => state.applicationInstrumentId,
  
  
  GET_APPLICATION_TRANSPORT: state => state.applicationTransport,
  GET_APPLICATIONS_TRANSPORT_ID: state => state.applicationTransportId,


  GET_APPLICATION_STATUS: state => state.applicationStatus,
  GET_APPLICATION_AUTHOR: state => state.applicationAuthor,
  GET_APPLICATION_TYPE: state => state.applicationType,
  GET_APPLICATION_STATUS_TIMELINE: state => state.applicationStatusTimeLine,
  GET_APPLICATION_STATUS_TIMELINE_BY_ID: state => state.applicationStatusTimeLineById,
  GET_APPLICATION_STATUS_CHILD_TIMELINE: state => state.applicationStatusChildTimeLine,
  
  
  SET_APPLICATION_STATUS_MOVEMENT_TIMELINE: state => state.applicationStatusMovementTimeLine,
  GET_APPLICATION_MOVEMENT: state => state.applicationMovement,


  GET_APPLICATIONS_PURCHASE: state => state.purchase,
  GET_APPLICATIONS_INSTRUMENT_RETURN: state => state.instrumentReturn,
  GET_APPLICATIONS_GOOD_RETURN: state => state.goodReturn,
  GET_CONTRACT_DETAILS:state =>state.contractDetail,



  GET_APPLICATION_FOR_BRIGADE_WORKS: state =>state.brigadeWorks,
  GET_ONE_APPLICATION_FOR_BRIGADE_WORKS: state =>state.oneBrigadeWorks,


  GET_WORK_PARTIAL_PAYMENTS: state =>state.brigadeWorks,
  GET_ONE_WORK_PARTIAL_PAYMENTS: state =>state.oneBrigadeWorks,
  
  
  
  GET_WORKER_WRITE_OFF_FOR_GOOD: state =>state.worker_write_off_for_good,
  GET_WORKER_WRITE_OFF_FOR_INSTRUMENT: state =>state.worker_write_off_for_instrument,
}
